import Vue from 'vue'
import Vuex from 'vuex'
import moment from 'moment'
import { findIndex, isNil, orderBy } from 'lodash'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    apiReady: false,
    mode: null,
    profilsData: null,
    currentUser: null,
    events: [],
    states: [],
    allStates: [],
    calendarEvents: {},
    origins: [],
    companies: [],
    promoteurs: [],
    poles: [],
    runningOptions: [],
    userId: null,
    wishlists: [],
    gApiReady: false,
    gProfile: null,
    googleLogged: false,
    runningOptionsLoaded: false,
    runningDenunciationsLoaded: false,
    runningDenunciations: [],
    lastOption: null, // store .pk of last option
    displayRemuneration: true,
    canDisplayRemuneration: false,
    configs: null,
    internalUsersLength: 0,
    googleCalendars: [],
    scrollToEl: null,
    scrollToPage: null,
    contratDeResa: null,
    quickview: {},
    modal: {},
    device: 'desktop'
  },
  mutations: {
    setDevice (state, { device }) {
      state.device = device
    },
    setApiReadyState (state, { isReady }) {
      state.apiReady = isReady
    },
    setConfigs (state, configs) {
      state.configs = configs
      state.mode = configs.MODE
    },
    addEvent (state, { event }) {
      state.events.push(event)
    },
    addCalendarEvent (state, { event, key, type }) {
      if ((key in state.calendarEvents) === false) {
        Vue.set(state.calendarEvents, key, {
          'accesses': {},
          'rdvs': {},
          'options': {},
          'reminders': {},
          'users': {},
          'calendarEvents': {}
        })
      }
      event._type = type
      Vue.set(state.calendarEvents[key][type], event.pk, event)
    },
    removeCalendarEvent (state, { eventPk, type }) {
      Object.entries(state.calendarEvents).forEach(([key, val]) => {
        if (eventPk in val[type]) {
          Vue.delete(state.calendarEvents[key][type], eventPk)
        }
      })
    },
    removeAllCalendarEvents (state, { type }) {
      Object.entries(state.calendarEvents).forEach(([key, val]) => {
        if (type in state.calendarEvents[key]) {
          Vue.set(state.calendarEvents[key], type, {})
        }
      })
    },
    setProfilsData (state, { data }) {
      state.profilsData = data
    },
    setStates (state, { states }) {
      state.states = states
    },
    setAllStates (state, { states }) {
      state.allStates = states
    },
    setEvents (state, { events }) {
      state.events = events
    },
    setUsers (state, { users }) {
      state.internalUsersLength = users
    },
    setRunningOptions (state, { options }) {
      state.runningOptions = options
      state.runningOptionsLoaded = true
    },
    addRunningOption (state, { option }) {
      state.runningOptions.unshift(option)
    },
    updateRunningOption (state, { option }) {
      let optionPk = option.pk
      let targetIndex = findIndex(state.runningOptions, x => {
        return x.pk === optionPk
      })
      if (targetIndex > -1) {
        Vue.set(state.runningOptions, targetIndex, option)
      }
    },
    setRunningDenunciations (state, { denunciations }) {
      state.runningDenunciations = denunciations
      state.runningDenunciationsLoaded = true
    },
    addRunningDenunciation (state, { denunciation }) {
      state.runningDenunciations.unshift(denunciation)
    },
    updateRunningDenunciation (state, { denunciation }) {
      let denunciationPk = denunciation.pk
      let targetIndex = findIndex(state.runningDenunciations, x => {
        return x.pk === denunciationPk
      })
      if (targetIndex > -1) {
        Vue.set(state.runningDenunciations, targetIndex, denunciation)
      }
    },
    setCurrentUser (state, { user }) {
      Vue.set(state, 'currentUser', user)
    },
    patchCurrentUser (state, data) {
      Vue.set(state, 'currentUser', Object.assign(state.currentUser, data))
    },
    login (state, { userId, user }) {
      state.userId = userId
      state.currentUser = user
    },
    logout (state) {
      state.currentUser = null
      state.userId = null
      state.quickview = {}
      state.modal = {}
    },
    removeEvent (state, { eventPk }) {
      let targetIndex = findIndex(state.events, x => {
        return x.pk === eventPk
      })
      state.events.splice(targetIndex, 1)
    },
    removeEvents (state) {
      state.events = []
    },
    editEvent (state, { data }) {
      let targetIndex = findIndex(state.events, x => {
        return x.pk === data.pk
      })
      state.events.splice(targetIndex, 1, data)
    },
    setWishlist (state, { wishlists }) {
      state.wishlists = wishlists
    },
    addWishlist (state, { wishlist }) {
      state.wishlists.push(wishlist)
    },
    removeWishlist (state, { wishlistPk }) {
      let targetIndex = findIndex(state.wishlists, x => {
        return x.pk === wishlistPk
      })
      state.wishlists.splice(targetIndex, 1)
    },
    loadGoogleApi (state) {
      state.gApiReady = true
    },
    googleLogin (state) {
      state.googleLogged = true
    },
    googleLogout (state) {
      state.googleLogged = false
    },
    setGoogleLoggedEmail (state, value) {
      state.googleLoggedEmail = value
    },
    setGoogleProfile (state, value) {
      state.gProfile = value
    },
    setOrigins (state, { origins }) {
      state.origins = origins
    },
    setCompanies (state, {companies}) {
      state.companies = companies
    },
    setPromoteurs (state, { promoteurs }) {
      state.promoteurs = promoteurs
    },
    setPoles (state, { poles }) {
      state.poles = poles
    },
    setLastOption (state, lastOption) {
      state.lastOption = lastOption
    },
    updatedisplayRemuneration (state, value) {
      state.displayRemuneration = value
    },
    setGoogleCalendar (state, calendar) {
      state.googleCalendars = calendar
    },
    setScrollEl (state, scrollToEl) {
      state.scrollToEl = scrollToEl
    },
    setScrollPage (state, scrollToPage) {
      state.scrollToPage = scrollToPage
    },
    setContratDeResa (state, contratDeResa) {
      state.contratDeResa = contratDeResa
    },
    setQuickview (state, quickview) {
      state.quickview = quickview
    },
    setModal (state, modal) {
      state.modal = modal
    },
    initState (state) {
      state.profilsData = null
      state.currentUser = null
      state.events = []
      state.calendarEvents = {}
      state.origins = []
      state.companies = []
      state.promoteurs = []
      state.poles = []
      state.runningOptions = []
      state.userId = null
      state.wishlists = []
      state.gApiReady = false
      state.gProfile = null
      state.googleLogged = false
      state.runningOptionsLoaded = false
      state.runningDenunciationsLoaded = false
      state.runningDenunciations = []
      state.displayRemuneration = true
      state.canDisplayRemuneration = false
    }
  },
  getters: {
    googleCalendarsId (state) {
      return state.googleCalendars.map(x => x.id)
    },
    isPromoteurMode (state) {
      return state.mode === 'PROMOTEUR'
    },
    isDistributeurMode (state) {
      return state.mode === 'DISTRIBUTEUR'
    },
    originGroups (state) {
      let options = []
      let tree = {}
      state.origins.filter(x => x.parent === null).forEach(parent => {
        tree[parent.pk] = parent
        tree[parent.pk]['children'] = []
      })

      state.origins.filter(x => x.parent !== null).forEach(child => {
        if (!tree[child.parent]) tree[child.parent] = { children: [] }
        tree[child.parent]['children'].push(child)
      })
      Object.values(tree).filter(x => x.children.length > 0).forEach(origin => {
        options.push({
          name: origin.name,
          children: origin.children
        })
      })

      let rest = Object.values(tree).filter(x => x.children.length === 0)

      options.push({
        name: 'Autres',
        children: rest
      })

      return options
    },
    pendingOptions (state) {
      return state.runningOptions.filter(x => x.status === 'pending')
    },
    pendingDenunciations (state) {
      return state.runningDenunciations.filter(x => x.status === 'pending')
    },
    reminders (state) {
      let reminders = []
      Object.entries(state.calendarEvents).forEach(([key, val]) => {
        if ('reminders' in val) {
          reminders = reminders.concat(Object.values(val.reminders))
        }
      })

      return reminders
    },
    googleRdvs (state) {
      let rdvs = []
      Object.entries(state.calendarEvents).forEach(([key, val]) => {
        if ('rdvs' in val) {
          rdvs = rdvs.concat(Object.values(val.rdvs).filter(x => {
            return isNil(x.google_calendar_id) === false && isNil(x.google_event_id) === false
          }))
        }
      })

      return rdvs
    },
    orderedEvents (state) {
      return orderBy(state.events, x => {
        return moment(x.created_on)
      }, 'desc')
    },
    newEvents (state) {
      return state.events.filter(x => x && x.is_new)
    },
    lastAnnouncement (state, getters) {
      if (getters.isLog) {
        return state.events.find(x => x && x.is_announcement && x.is_new)
      }
      return null
    },
    isLog (state) {
      return state.userId !== null && state.currentUser !== null
    },
    isAdmin (state, getters) {
      if (getters.isLog) {
        return state.currentUser.profil_type === 'admin'
      }
      return false
    },
    isOperator (state, getters) {
      if (getters.isLog) {
        return state.currentUser.profil_type === 'operator'
      }
      return false
    },
    isSuperAdmin (state, getters) {
      if (getters.isLog) {
        return state.currentUser.superadmin === true
      }
      return false
    },
    isExternal (state, getters) {
      if (getters.isLog) {
        return ['seller_ext', 'manager_ext'].includes(state.currentUser.profil_type)
      }
      return false
    },
    isSectorManager (state, getters) {
      if (getters.isLog) {
        return state.currentUser.profil_type === 'sector_manager'
      }
      return false
    },
    isManager (state, getters) {
      if (getters.isLog) {
        return ['manager_ext', 'manager'].includes(state.currentUser.profil_type)
      }
      return false
    },
    isSeller (state, getters) {
      if (getters.isLog) {
        return ['seller_ext', 'seller'].includes(state.currentUser.profil_type)
      }
      return false
    },
    isEditor (state, getters) {
      if (getters.isLog) {
        return state.currentUser.profil_type === 'editor'
      }
      return false
    },
    isApi (state, getters) {
      if (getters.isLog) {
        return state.currentUser.profil_type === 'api'
      }
      return false
    },
    currentUserName (state) {
      if (state.currentUser && isNil(state.currentUser.first_name) === false && isNil(state.currentUser.last_name) === false) {
        return state.currentUser.first_name + ' ' + state.currentUser.last_name
      }
      return null
    },
    currentUserPicture (state) {
      if (state.currentUser && state.currentUser.picture && state.currentUser.picture.path) {
        return state.currentUser.picture
      }
      return null
    },
    currentUserCurrency (state) {
      if (state.configs.CURRENCY) {
        return state.configs.CURRENCY
      }
      return null
    },
    currentUserCountry (state) {
      if (state.configs.COUNTRY) {
        return state.configs.COUNTRY
      }
      return null
    },
    currentUserProfil (state) {
      if (state.currentUser) {
        return state.currentUser.profil_type
      }
      return null
    },
    currentUserPk (state) {
      if (state.currentUser) {
        return state.currentUser.pk
      }
      return null
    },
    currentCompany (state) {
      if (state.currentUser && state.currentUser.company) {
        return state.currentUser.company
      }
      return null
    },
    currentCompanyPk (state) {
      if (state.currentUser && state.currentUser.company) {
        return state.currentUser.company.pk
      }
      return null
    },
    currentUserPreferences (state) {
      if (state.currentUser && state.currentUser.app_preferences) {
        let data = Object.assign({}, state.currentUser.app_preferences)
        return data
      }
      return null
    },
    displayRemuneration (state) {
      if (state.currentUser) {
        if (state.currentUser.can_display_remuneration) {
          return state.currentUser.display_remuneration
        } else return false
      }
      return null
    },
    canDisplayRemuneration (state) {
      if (state.currentUser && state.currentUser.can_display_remuneration) {
        return state.currentUser.can_display_remuneration
      }
      return null
    },
    googleEmail (state) {
      if (state.googleLogged && state.gProfile) {
        let primaryAddress = state.gProfile.emailAddresses.find(x => {
          return x.metadata.primary === true
        })
        return primaryAddress.value
      }
      return null
    },
    configs (state) {
      return state.configs
    }
  }
})



// WEBPACK FOOTER //
// ./src/services/store/index.js